var validator = new function() {
    this.methods = function() {
        jQuery.validator.addMethod("phone", function(value, element) {
            var slug = /^[0-9\-]+$/;
            return slug.test(value) && value.length == 9;
        }, Laravel.lang.validation.phone);
    };
};

$(document).ready(function() {
    // /**
    //  * cookies
    //  */
    // // $("[data-cookies-close]").bind("click", function() {
    // //     $("[data-cookies-container]").fadeOut();
    // // });
    //
    // /**
    //  * slider
    //  */
    // $('[data-front-slider]').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     fade: true,
    //     autoplay: true,
    //     autoplaySpeed: 2000
    // });
    //
    // /**
    //  * popup
    //  */
    // //if($("[data-popup-container]").length == 1){
    // $("[data-popup-container]").modal({
    //     fadeDuration: 1000,
    //     fadeDelay: 0.50
    // });
    // //}
    //
    // validator.methods();

    $('body').on('click','[data-category-moreposts]', function() {
        var data = {
            category_id:$("[data-category-id]").data("category-id"),
            page_nr: parseInt($("[data-category-page]").data("category-page"))+1,
            _token: Laravel.csrfToken
        };

        $(".newsLoader").show();

        me = $(this);

        $.ajax({
            url: "/module/postfromcategory",
            method: "POST",
            data: data,
            dataType: "json",
            success: function(data) {
                var wrapper = me.closest("[data-category-wrapper]").find("[data-category-box]");

                if(data.posts.length == 0){
                    $(".loader").remove();
                    $(".newsLoader").hide();
                    $(me).fadeOut(function(){
                        $(me).remove();
                    });
                }else{
                    var template = $("#entry-template").html();
                    var stone = Handlebars.compile(template)(data);
                    wrapper.append(stone);                    
                    wrapper.data('category-page',data.page);
                    $(".loader").data("offset",data.offset);
                    //addNews();
                    $(".newsLoader").hide();
                    if(wrapper.find(".news-item").length == parseInt(wrapper.attr('data-category-postamong'))){
                        $(".loader").remove();
                        $(me).fadeOut(function(){
                            $(me).remove();
                        });
                    }
                }
            }
        });
        return false;
    });
});
